import { Stack, Text } from "@certn/cascadia";
import { Icon } from "@certn/cascadia-react";
import { formatDateTime } from "@certn/utils";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { FulfillmentNotes as FulfillmentNotesSchema } from "../types";

interface FulfillmentNotesProps {
  fulfillmentNotes: FulfillmentNotesSchema;
}

export function FulfillmentNotes(props: FulfillmentNotesProps) {
  const { t } = useTranslation();
  const { fulfillmentNotes } = props;
  const styles = useStyles();

  return (
    <div className={styles.container} data-testid="fulfillment-notes-container">
      <div
        className={styles.headerContainer}
        data-testid="fulfillment-notes-header"
      >
        <Icon name="sticky_note_2" />
        <Text style="global/heading-medium">{t("Fulfillment notes")}</Text>
      </div>
      {fulfillmentNotes.notes.map((note, index) => {
        return (
          <Stack
            key={index}
            gap="space-1"
            data-testid="fulfillment-note-container"
          >
            <Text
              style="global/info-label"
              testID="fulfillment-note-datetime"
              color="text-weak"
            >
              {formatDateTime(note.created, "MMMM dd, yyyy h:mm a")}
            </Text>
            <Text
              style="global/body-secondary"
              testID="fulfillment-note-content"
            >
              {note.content}
            </Text>
          </Stack>
        );
      })}
    </div>
  );
}

function useStyles() {
  return {
    container: css({
      backgroundColor: "var(--background-input-disabled)",
      gap: "var(--space-4)",
      display: "flex",
      flexDirection: "column",
      padding: "var(--space-4)",
      paddingBottom: "var(--space-6)",
      borderRadius: "var(--border-radius-3)",
      margin: "var(--space-4)",
    }),
    headerContainer: css({
      display: "flex",
      gap: "var(--space-2)",
      alignItems: "center",
    }),
  };
}
